export const AgentLineChat = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22 6.59961C22 4.94275 20.6569 3.59961 19 3.59961H5C3.34315 3.59961 2 4.94276 2 6.59961V15.5996C2 17.2565 3.34315 18.5996 5 18.5996H6.5V21.0996L11.5 18.5996H19C20.6569 18.5996 22 17.2565 22 15.5996V6.59961Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
